import {

    useMemo,

    useState

} from "react";

import Card from "../shared/Card";

import FollowupToolbar from "./FollowupToolbar";
import FollowupFilters from "./FollowupFilters";
import FollowupTimeline from "./FollowupTimeline";
import FollowupDrawer from "./FollowupDrawer";
import "./followup.css"
export default function FollowupCard({

    followups=[],

    onCreate,

    onComplete,

    onDelete

}){

    const [

        filter,

        setFilter

    ]=useState("all");

    const [

        drawerOpen,

        setDrawerOpen

    ]=useState(false);

    const counts=useMemo(()=>{

        const overdue=

            followups.filter(item=>

                item.status==="pending"

                &&

                new Date(item.followup_at)

                <

                new Date()

            ).length;

        return{

            all:followups.length,

            pending:followups.filter(item=>

                item.status==="pending"

            ).length,

            completed:followups.filter(item=>

                item.status==="completed"

            ).length,

            overdue

        };

    },[

        followups

    ]);

    return(
<>
        <Card>

            <FollowupToolbar

                total={followups.length}

                onCreate={()=>

                    setDrawerOpen(true)

                }

            />

            <FollowupFilters

                value={filter}

                counts={counts}

                onChange={setFilter}

            />

            <FollowupTimeline

                followups={followups}

                filter={filter}

                onComplete={onComplete}

                onDelete={onDelete}

            />

           

        </Card>
 <FollowupDrawer

                open={drawerOpen}

                onClose={()=>

                    setDrawerOpen(false)

                }

                onSave={async values=>{

                    await onCreate?.(

                        values

                    );

                    setDrawerOpen(false);

                }}

            /></>
    );

}